class GalleryBloc extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("slider-component");
    this.images = this.querySelectorAll(".gallery-bloc__image");

    if (this.images.length > 0) {
      this.handleMobileLayout();
      window.addEventListener("resize", () => this.handleMobileLayout());
    }
  }

  handleMobileLayout() {
    if (window.innerWidth < 750) {
      this.addEndMargin();
      this.centerSlider();
    }
  }

  addEndMargin() {
    const style = document.createElement("style");
    style.textContent = `
      @media screen and (max-width: 749px) {
        .gallery-bloc__images-container::after {
          content: '';
          display: block;
          min-width: 12px;
          height: 1px;
        }
      }
    `;
    document.head.appendChild(style);
  }

  centerSlider() {
    const containerWidth = this.slider.offsetWidth;
    const totalWidth = Array.from(this.images).reduce((total, image) => {
      return total + image.offsetWidth + 8; // 8px for gap
    }, 0);

    const scrollLeft = (totalWidth - containerWidth) / 2 + 20;
    this.slider.scrollLeft = scrollLeft;
  }
}

customElements.define("gallery-bloc", GalleryBloc);
